/* eslint-disable */
<template>
    <div class="row mb-8">
        <div class="col d-flex justify-content-start">
            <span class="title">{{ $t('products.add') }}</span>
        </div>
        <div class="col d-flex gap-2 justify-content-end">
            <genericBtnComponent :loading="loading" :disabled="isAddDisabled || loading" :ClickFun="submitProduct"
                svg="1" :Title="$t('products.save')" />
        </div>
    </div>
    <v-form ref="form" @submit.prevent="submitProduct">
        <v-card elevation="0">
            <div class="row ma-4">
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.BasicInformations') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">{{ $t('products.supplier') }}<span
                                class="red">*</span></v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete :style="MySupplier ? 'pointer-events: none;' : ''" v-model="product.supplierId"
                            :items="suppliers" item-title="name" item-value="supplierId" persistent-placeholder
                            variant="outlined" :placeholder="$t('placeholder.select', { itm: $t('products.supplier') })"
                            hide-details>
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                                    {{ item.brandName }}
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">{{ $t('products.categories') }}<span
                                class="red">*</span></v-card-title>
                    </div>
                    <div class="row">
                        <autocompleteGrouped v-model="product.categories" :items="flattenedCategories"
                            :placeholder="$t('placeholder.select', { itm: $t('products.categories') })" />
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.title') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="product.name" id="Title" name="Title" maxlength="128" hide-details
                            persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('products.title') })"
                            variant="outlined"></v-text-field>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.price') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="product.price" id="price" type="number" name="price" maxlength="9"
                            @update:model-value="product.price = (product.price || '').toString().replace(/[^0-9.]/g, '')" hide-details
                            persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('products.price') })"
                            variant="outlined" :suffix="currency"></v-text-field>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.mark') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete v-model="product.mark" :items="marks" item-title="brandName"
                            item-value="brandName" persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('products.mark') })" variant="outlined"
                            hide-no-data hide-details></v-autocomplete>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.tax') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="product.tax" id="tax" type="number" name="tax" maxlength="5"
                            density="compact" hide-details persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('products.tax') })" variant="outlined"
                            suffix="%"></v-text-field>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.type') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete v-model="product.type" :items="productType" item-title="name" item-value="id"
                            persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('products.type') })"
                            variant="outlined" hide-no-data hide-details></v-autocomplete>
                    </div>
                </div>
                <div class="col-12 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.description') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-textarea id="Comment" v-model="product.description" variant="outlined"
                            :placeholder="$t('placeholder.enter', { itm: $t('products.description') })" hide-details
                            maxlength="500" class="py-3" rows='5' no-resize></v-textarea>
                    </div>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.tags') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>

                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.tags') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete v-model="newTag" :items="suggestedTags"
                            :append-inner-icon="newTag ? 'mdi-plus' : ''" @click:append-inner="addTag"
                            @keyup.enter="addTag" persistent-placeholder :placeholder="$t('products.PlaceHolderTags')"
                            variant="outlined" v-model:search="newTag" hide-no-data hide-details>
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item v-bind="props" variant="text" :id="index" :name="item.name"
                                    @click="addTag">
                                    {{ item.name }}
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                    </div>
                </div>
                <div class="col-8 justify-content-center align-items-center align-self-center">
                    <div class="tags-list">
                        <chipsButton v-for="(tag, index) in product.tags" :key="index" class="ma-1" closable
                            color="primary" :clickClose="removeTag" :tagIndex="index" :title="tag">
                        </chipsButton>
                        <div v-if="product.tags.length == 0" class="text-caption text-grey pa-2">
                            {{ $t('products.noTagsAdded') }}
                        </div>
                    </div>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.options') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row my-2" style="max-width: 500px; justify-self: center;">
                        <v-btn color="primary" variant="outlined" @click="addOption" prepend-icon="mdi-plus">
                            {{ $t('products.addOption') }}
                        </v-btn>
                    </div>
                </div>
                <div class="col-12 justify-content-center">
                    <v-card v-for="(option, optionIndex) in product.options" :key="optionIndex" variant="outlined"
                        class="ma-2 pa-4">
                        <div class="col-12 justify-content-start">
                            <div class="row">
                                <v-card-title class="text-left">
                                    {{ $t('products.optionName') }}<span class="red">*</span>
                                </v-card-title>
                            </div>
                            <div class="row">
                                <v-text-field v-model="option.name" persistent-placeholder hide-details
                                    :placeholder="$t('placeholder.enter', { itm: $t('products.optionName') })"
                                    variant="outlined"></v-text-field>
                                <span class="hint">{{ $t('products.exampleOptions') }}</span>
                            </div>
                        </div>
                        <div class="col-12 justify-content-start">
                            <div class="row">
                                <v-card-title class="text-left">
                                    {{ $t('products.optionValues') }}<span class="red">*</span>
                                </v-card-title>
                            </div>
                            <div class="row">
                                <v-combobox v-model="option.values" persistent-placeholder hide-details
                                    :placeholder="$t('placeholder.enter', { itm: $t('products.optionValues') })"
                                    variant="outlined" multiple chips closable-chips></v-combobox>
                                <span class="hint">{{ $t('products.pressEnterToAddValues') }}</span>
                            </div>
                        </div>

                        <v-btn color="error" variant="text" @click="removeOption(optionIndex)" class="mt-2"
                            prepend-icon="mdi-delete">
                            {{ $t('products.removeOption') }}
                        </v-btn>
                    </v-card>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.variants') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row my-4" style="max-width: 500px; justify-self: center;">
                        <v-btn color="primary" variant="outlined" @click="generateVariants" prepend-icon="mdi-refresh"
                            :disabled="!hasValidOptions">
                            {{ $t('products.generateVariants') }}
                        </v-btn>
                    </div>

                    <v-card v-if="product.variants.length" variant="outlined">
                        <v-table>
                            <thead>
                                <tr>
                                    <th class="text-center">{{ $t('products.variant') }}</th>
                                    <th class="text-center">{{ $t('products.price') }} <span class="red">*</span></th>
                                    <th class="text-center">{{ $t('products.quantityMin') }} <span class="red">*</span></th>
                                    <th class="text-center">{{ $t('products.collectionTimePerHour') }} <span class="red">*</span></th>
                                    <th class="text-center">{{ $t('products.inventory') }}</th>
                                    <th class="text-center">{{ $t('products.manageInventory') }}</th>
                                    <th class="text-center">{{ $t('products.actions') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(variant, index) in product.variants" :key="variant.id">
                                    <td>{{ getVariantTitle(variant) }}</td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.PriceAdjustment" type="number"
                                            density="compact" hide-details :suffix="currency" variant="outlined" />
                                    </td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.QuantityMinCommanded" type="number"
                                            density="compact" hide-details variant="outlined" />
                                    </td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.CollectionTimePerHour" type="number"
                                            :min="0" density="compact" hide-details suffix="H" variant="outlined"
                                            @update:model-value="variant.CollectionTimePerHour = Math.max(0, Number($event))" />
                                    </td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.Stock" type="number" density="compact"
                                            hide-details variant="outlined" :disabled="!variant.manage_inventory" />
                                    </td>
                                    <td class="text-center" style="width: 100px">
                                        <v-switch v-model="variant.manage_inventory" density="compact" color="primary"
                                            hide-details class="ma-0 pa-0" />
                                    </td>
                                    <td class="text-center" style="width: 100px">
                                        <v-btn icon="mdi-delete" variant="text" color="error" size="small"
                                            @click="removeVariant(index)" />
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card>
                    <v-card v-else variant="outlined" class="pa-4 text-center text-grey">
                        {{ $t('products.noVariantsMessage') }}
                    </v-card>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.images') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.images') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row" style="max-width: 500px; justify-self: center;">
                        <uploadMultiDocument v-on:addMultiDocument="setProductImages" :showUpload="true"
                            :fileTypes="fileTypes" subTitle='products.uploadImageHint'>
                            <template v-slot:DocumentsList>
                                <div style="max-height: 60px; overflow-y:scroll; overflow-x: hidden;">
                                    <div v-for="(fileName, index) in MultiFileList" :key="index">
                                        <div @mouseover="setHover(index)" @mouseout="setHover(null)"
                                            style="display: flex; position: relative;">
                                            <span
                                                style="color: blue; cursor: pointer; text-align: start; max-width: 95%;"
                                                :title="fileName">{{ fileName
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </uploadMultiDocument>
                    </div>
                </div>

                <v-row class="mt-5">
                    <v-col v-for="(preview, index) in imagePreviews" :key="index" cols="12" sm="6" md="4" lg="3">
                        <v-card class="mx-auto">
                            <v-img :src="preview.url" height="200" class="bg-grey-lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey-lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                            <v-icon @click="DeleteImageByIndex(index)" class="ml-2"
                                style="color: red">mdi-close-circle-outline</v-icon>
                        </v-card>
                    </v-col>
                </v-row>

                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.video') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.video') }}
                        </v-card-title>
                    </div>
                    <div v-if="!videoPreviews[0]" class="row" style="min-width: 460px; max-width: 460px; justify-self: center;">
                        <uploadVideo v-on:addVideo="setProductVideos" :showUpload="true"
                            subTitle='products.uploadVideoHint'>
                        </uploadVideo>
                    </div>
                </div>

                <v-row class="mt-5" v-if="videoPreviews[0]">
                    <v-col cols="12" sm="12" md="12" lg="12">
                        <v-card class="mx-auto">
                            <div style="position: relative;">
                                <video :src="videoPreviews[0].url" controls height="200"
                                    style="width: 100%; background-color: #f5f5f5;"></video>
                                <v-icon @click="DeleteVideosByIndex(0)" class="ml-2"
                                    style="color: red; position: absolute; top: 5px; right: 5px; cursor: pointer;">
                                    mdi-close-circle-outline
                                </v-icon>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

            </div>
        </v-card>
    </v-form>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import {
    saveProduct,
    getAllSuppliersForProducts,
    getAllCategories,
    isSupplier,
    idSupplier,
    getAllBrands,
    getAllProductTypes
} from "@/api";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import { useRouter } from "vue-router";
import chipsButton from '@/genericComponent/chipsButton.vue';
import autocompleteGrouped from '@/genericComponent/autocompleteGrouped.vue';
import uploadMultiDocument from "@/genericComponent/uploadMultiDocument.vue";
import uploadVideo from "@/genericComponent/uploadVideo.vue";
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const router = useRouter();
const form = ref(null);
const loading = ref(false);

const product = ref({
    name: '',
    description: '',
    price: null,
    inventory: null,
    categories: [],
    tags: [],
    options: [],
    variants: [],
    variantsTo: [],
    images: [],
    videos: [],
    msg: [],
    supplierId: null,
    mark: '',
    type: null
});

const fileTypes = [{ mimeType: "image/jpeg", name: "JPEG" },
{ mimeType: "image/png", name: "PNG" }];
const images = ref([]);
const videos = ref([]);
const suppliers = ref([]);
const categories = ref([]);
const imagePreviews = ref([]);
const videoPreviews = ref([])
const MySupplier = ref(null);
const marks = ref([]);
const productType = ref([]);

const fetchCategoriesAndSuppliers = async () => {
    try {
        const [categoriesResponse, suppliersResponse] = await Promise.all([
            getAllCategories(),
            getAllSuppliersForProducts()
        ]);
        categories.value = categoriesResponse.data;
        suppliers.value = suppliersResponse.data;

        if (isSupplier()) {
            MySupplier.value = idSupplier();
            product.value.supplierId = MySupplier.value;
        }
    } catch (error) {
        console.error('Error fetching categories or suppliers:', error);
    }
};

const isAddDisabled = computed(() => {
    return !product.value.name ||
        !product.value.description ||
        !product.value.price ||
        !product.value.supplierId ||
        !product.value.mark ||
        !product.value.type ||
        !product.value.tax ||
        product.value.categories.length === 0 ||
        product.value.variants.length === 0 ||
        product.value.tags.length === 0 ||
        product.value.images.length === 0;
});

const fetchMarks = async () => {
    try {
        const response = await getAllBrands(); // Fetch brands
        const brands = response.data;

        // Extract brand names for the autocomplete
        marks.value = brands.map(brand => ({
            brandName: brand.brandName,
            brandId: brand.brandId,
            logoUrl: brand.logoUrl // Optional: if you want to display logos
        }));
    } catch (error) {
        console.error('Error fetching brands:', error);
    }
};


const fetchProductType = async () => {
    try {
        const response = await getAllProductTypes();
        const types = response.data;

        productType.value = types.map(brand => ({
            name: brand.name,
            id: brand.id,
        }));
    } catch (error) {
        console.error('Error fetching brands:', error);
    }
};

onMounted(() => {
    fetchCategoriesAndSuppliers();
    fetchMarks();
    fetchProductType();
});

const flattenedCategories = computed(() => {
    const flatten = (cats, parentId = null, level = 0) => {
        return cats.reduce((acc, category) => {
            if (category.parent_category_id === parentId) {
                const flatCategory = {
                    ...category,
                    name: '  '.repeat(level) + category.name
                };
                acc.push(flatCategory);
                acc.push(...flatten(cats, category.categoryId, level + 1));
            }
            return acc;
        }, []);
    };
    return flatten(categories.value);
});

const newTag = ref('');

const suggestedTags = ref([
    'New Arrival',
    'Best Seller',
    'Limited Edition',
    'Sale',
    'Premium',
    'Eco-friendly',
    'Handmade',
    'Custom',
    'Exclusive'
]);

function addTag() {
    const tag = newTag.value.trim();
    if (tag && !product.value.tags.includes(tag)) {
        product.value.tags.push(tag);
        newTag.value = '';
    }
    if (suggestedTags.value.includes(tag)) {
        const index = suggestedTags.value.findIndex((suggestedTag) => suggestedTag === tag);
        suggestedTags.value.splice(index, 1);
    }
}

function removeTag(index) {
    product.value.tags.splice(index, 1);
}

function removeVariant(index) {
    product.value.variants.splice(index, 1);
}

function getVariantTitle(variant) {
    const optionNames = product.value.options.map(opt => opt.name);
    return variant.comb
        .map((value, index) => `${optionNames[index]}: ${value}`)
        .join(' / ');
}

const hasValidOptions = computed(() => {
    return product.value.options.length > 0 &&
        product.value.options.every(option =>
            option.name &&
            option.values &&
            option.values.length > 0
        );
});

function addOption() {
    product.value.options.push({
        name: '',
        values: []
    });
}

function removeOption(index) {
    product.value.options.splice(index, 1);
    generateVariants();
}

function generateVariants() {
    if (!hasValidOptions.value) return;

    const generateCombinations = (arrays) => {
        return arrays.reduce((acc, curr) => {
            const temp = [];
            acc.forEach(x => {
                curr.forEach(y => {
                    temp.push([...x, y]);
                });
            });
            return temp;
        }, [[]]);
    };

    const optionArrays = product.value.options.map(option => option.values);
    const combinations = generateCombinations(optionArrays);

    product.value.variants = combinations.map(combination => {
        const sku = `SKU${crypto.randomUUID().substring(0, 6).toUpperCase()}`;
        const options = combination.map((value, index) => ({
            Name: product.value.options[index].name,
            Value: value

        }));

        return {
            SKU: sku,
            comb: combination,
            Options: options,
            price: product.value.price,
            inventory: product.value.inventory,
            manage_inventory: true,
            QuantityMinCommanded: product.value.QuantityMinCommanded,
            CollectionTimePerHour: product.value.CollectionTimePerHour
        };
    });

    product.value.variantsTo = combinations.map(combination => {
        const sku = `SKU${crypto.randomUUID().substring(0, 6).toUpperCase()}`;
        const options = combination.map((value, index) => ({
            Name: product.value.options[index].name,
            Value: value
        }));
        return {
            SKU: sku,
            options: options,
            PriceAdjustment: product.value.price,
            Stock: product.value.inventory,
            QuantityMinCommanded: product.value.QuantityMinCommanded,
            CollectionTimePerHour: product.value.CollectionTimePerHour
        };
    });
}

const handleFileChange = async (newFiles) => {
    imagePreviews.value = [];

    if (!newFiles) return;

    const newFiles2 = product.value.images;
    for (const file of newFiles2) {
        try {
            const preview = await createImagePreview(file);
            imagePreviews.value.push({
                url: preview,
                name: file.name,
                size: file.size,
                file: file
            });
        } catch (error) {
            console.error('Error creating preview:', error);
        }
    }
};

const handleFileVideoChange = async (files) => {
    if (!files || files.length === 0) {
        product.value.videos = []
        videoPreviews.value = []
        return
    }

    const newFile = product.value.videos[0]

    try {
        const preview = await createImagePreview(newFile)
        videoPreviews.value = [
            {
                url: preview,
                name: newFile.name,
                size: newFile.size,
                file: newFile,
                isExisting: false,
            }
        ]
    } catch (error) {
        console.error('Error creating preview:', error)
    }
}

const createImagePreview = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            resolve(event.target.result);
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(file);
    });
};

async function submitProduct() {
    const { valid } = await form.value.validate();

    if (!valid) return;

    loading.value = true;

    try {
        const formData = new FormData();

        const dataToSend = {
            Name: product.value.name,
            Description: product.value.description,
            BasePrice: product.value.price,
            inventory: product.value.inventory,
            CategoryIds: product.value.categories,
            Tags: product.value.tags,
            options: product.value.options,
            Variants: product.value.variants,
            Images: product.value.images,
            Videos: product.value.videos,
            SupplierId: product.value.supplierId,
            Marque: product.value.mark,
            ProductType: product.value.type,
        };
        const transformedArray = dataToSend.Variants.map(({ PriceAdjustment, SKU, Stock, Options, QuantityMinCommanded, CollectionTimePerHour }) => ({
            PriceAdjustment: PriceAdjustment || 0, SKU, Stock: Stock || 0, Options, QuantityMinCommanded: QuantityMinCommanded || 0, CollectionTimePerHour: CollectionTimePerHour || 0
        }));

        formData.append('Name', dataToSend.Name);
        formData.append('Description', dataToSend.Description);
        formData.append('Variants', JSON.stringify(transformedArray));
        formData.append('BasePrice', dataToSend.BasePrice);
        formData.append('Tax', product.value.tax);
        formData.append('Tags', JSON.stringify(dataToSend.Tags));
        formData.append('CategoryIds', JSON.stringify(dataToSend.CategoryIds));
        formData.append('SupplierId', dataToSend.SupplierId);
        formData.append("Marque", dataToSend.Marque);
        formData.append("ProductType", dataToSend.ProductType);
        for (let i = 0; i < product.value.images.length; i++) {
            formData.append('Images', product.value.images[i]);
        }
        if (product.value.videos.length) {
            formData.append('Videos', product.value.videos[0]);
        }

        await saveProduct(formData);

        ActiveSavedSnackBar();

        form.value.reset();
        product.value = {
            name: '',
            description: '',
            price: '',
            tax: null,
            type: null,
            inventory: null,
            categories: [],
            tags: [],
            options: [],
            variants: [],
            variantsTo: [],
            images: [],
            videos: [],
            mark: '',
            supplierId: null
        };
        images.value = [];
        videos.value = [];

    } catch (error) {
        ActiveWarningSnackBar();
        console.error('Error submitting product:', error);
    } finally {
        loading.value = false;
        await router.push({ name: 'Products' });
    }
}

const setProductImages = (value) => {
    product.value.images.push(...value);
    handleFileChange(value);
};

const setProductVideos = (value) => {
    product.value.videos= [value];
    handleFileVideoChange(value);
};

const DeleteImageByIndex = (index) => {
    if (index >= 0 && index < product.value.images.length) {
        product.value.images.splice(index, 1);
    } else {
        console.warn("Index out of bounds");
    }
    handleFileChange(product.value.images);
};

const DeleteVideosByIndex = (index) => {
    if (index >= 0 && index < product.value.videos.length) {
        product.value.videos.splice(index, 1);
    } else {
        console.warn("Index out of bounds");
    }
    handleFileChange(product.value.videos);
};

const currency = computed(() => window.VUE_APP_CURRENCY);

function getParent(name) {
    let p = proxy.$parent;
    while (typeof p !== 'undefined') {
        if (p.$options.name === name) {
            return p;
        } else {
            p = p.$parent;
        }
    }
    return false;
}

function ActiveWarningSnackBar() {
    const parent = getParent('MainLayout');
    if (parent) parent.ActiveWarningSnackBar();
}

function ActiveSavedSnackBar() {
    const parent = getParent('MainLayout');
    if (parent) parent.ActiveSavedSnackBar();
}
</script>

<style scoped>
.v-card {
    border-radius: 8px;
}

.v-btn {
    text-transform: none;
}

.options-card {
    border: 1px solid #e0e0e0;
    margin-bottom: 16px;
}

.variant-table {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
}

.description-editor {
    border-radius: 4px;
}

.preview-content {
    min-height: 200px;
    white-space: pre-wrap;
    background-color: #f8f9fa;
}

.tags-container {
    border-radius: 4px;
}

.tags-input-container {
    max-width: 400px;
}

.tags-list {
    justify-content: center !important;
    align-items: center !important;
    min-height: 44px;
    border-radius: 4px;
}

.suggested-tags {
    padding-top: 8px;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}

:deep(.v-table) {
    background: transparent !important;
}

:deep(.v-table .v-table__wrapper > table) {
    padding: 0;
}

:deep(.v-table th) {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    background: #f5f5f5;
}

:deep(.v-table td) {
    padding: 8px 16px;
}

.slider {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    color: blue;
}


:deep(.v-autocomplete--single .v-field--dirty:not(.v-field--focused) input) {
    opacity: 1 !important;
}
</style>
